import React, { useContext, useEffect, useState } from 'react'
import './sass/PatientQrResult.sass'
import sadPC from './images/sadPC.svg'
import sadPhone from './images/sadPhone.svg'
import { useHttp } from '../../../hooks/http.hook'
import { AuthContext } from '../../../context/AuthContext'
import Status200or400 from './Components/Status200or400'
import PatientLogInPage from '../../Patient/PatinetAuth/PatientLogIn/PatientLogInPage'
import Page from '../../../components/Pages/Page'

export const QrResult = () => {

    const { request } = useHttp()
    const { token } = useContext(AuthContext)
    const [mobile, setMobile] = useState(false)
    const [status, setStatus] = useState(0)
    const [message, setMessage] = useState('')
    const [patientInfo, setPatientInfo] = useState({})
    const baseURL = process.env.REACT_APP_BASE_URL


    function getPartOfString(elem) {
        //функция для получения части url после оперделенной строки
        //На входе передаем знак - на выходе получаем часть url после этого знака
        const windowUrl = window.location.href
        const indexOfElem = windowUrl.indexOf(elem)
        return windowUrl.slice(indexOfElem + 1)
    }

    // Следим за размером окна
    window.addEventListener('resize', () => {
        setMobile(window.innerWidth < 1100)
    })

    const getQrResult = async () => {
        //const url = `${baseURL}/api/v2/general/patients/${token.userId}/checkIn?image=${getPartOfString('=')}`
        //const {data} = await request(url, 'GET', null, {Authorization: `Bearer ${token.token}`})
        //setStatus(data.status)
		
		let headers = {};
		headers['Content-Type'] = 'application/json';
		let data = JSON.stringify({
			qr: getPartOfString('=')
		})

        const response = await fetch('/api/v2/general/checkInQR', {
          method: 'POST',
          body: data,
          headers
        })
        const body = await response.json();
        const status = await response.status;
		console.log(status, body)
		if (status == 200) {
			setMessage(body.fio + ' : ' + body.diagnosis)
		} else {
			setMessage('Запрос неверный')
		}
		setStatus(status)

        return data
    }

    useEffect(() => {
        setMobile(window.innerWidth < 1100)
        //Получение резуольтата проверки анализа
        getQrResult()
    }, [])

    return (
        <>
            <Page name={'patient-qr-result__page'} mobile={true} animation={'fade-in-fwd'}>
                <div>
                    <div className={mobile && status === 500 ? 'sadPhoneContainer' : 'container'}>
                        {status === 500 ? <React.Fragment>
                            {mobile ? <img src={sadPhone} alt={' '}/> :
                              <div className="ImgContainer"><img alt={' '} src={sadPC}/></div>}
                            <div className='error'>
                                Внимание!
                            </div>
                            <div className='desc'>
                                <span style={{ color: '#ff007c', fontSize: '45px', marginBottom: '10px' }}>
                                    Вероятность подделки результата.
                                </span> <br />
                                Результат не найден. Пожалуйста попробуйте ввести код проверки повторно или обратитесь
                                в &nbsp;
                                <a href='https://infocab.net/appeal' style={{ textDecoration: 'underline' }}>службу
                                    поддержки</a> &nbsp;
                                на сайте.
                            </div>
                            {/*<div className='attentionn'>*/}
                            {/*    <p> Пожалуйста, обратитесь в МПЦ Отделение Флюорографии г. Казань ул. Гвардейская д.65,*/}
                            {/*        тел. <a*/}
                            {/*          href='tel:212-26-03'>212-26-03</a>, или напишите нам в службу поддержки*/}
                            {/*    </p>*/}
                            {/*</div>*/}
                        </React.Fragment> : ''}

                        {status === 200 || status === 400 ?
                          <div style={{background: '#ccc', padding:10, borderRadius:10}}>
						  {message}
						  </div>  : ''}
                    </div>


                </div>

            </Page>
        </>
    );
}



export const PatientQrResultSwitcher = _ => {
    // Функция проверяет на авторизацию и переводит в соответствующий компонент
    // Это нужно чтобы корректно отображать компоненты, так как роут CheckIn имеется как и для авторизованных пользователей, так не авторизованных.
    //const {isAuthenticated} = useContext(AuthContext)
    //if (isAuthenticated === true) {
        return <QrResult/>
    //} else {
    //    return <PatientLogInPage attention={true}/>
    //}
}
